export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 150 },
  { key: '2', headerName: 'Category Type', field: 'name', hide: false, width: 350 },
  { key: '3', headerName: 'Status', field: 'status', hide: false, width: 300 },
];
